import { CustomDate } from '@nemuru-eng/js-api-client';

import { ItemSelectOption } from '@/components/shared/components/LastActionsSelectOptions/types/ItemSelectOption';
import { MinimalRepositoryItem } from '@/components/shared/components/LastActionsSelectOptions/types/MinimalRepositoryItem';

interface LastActionsSelectOptionsProps<T> {
  repositoryOptions: T[];
  timeRanges: { daysAgo: number; title: string }[];
  renderDisplayElement: (option: T) => JSX.Element;
  timeSelectionHeaderElement: (title?: string) => JSX.Element;
}

export const LastActionsSelectOptions = <T extends MinimalRepositoryItem>({
  repositoryOptions,
  timeRanges,
  renderDisplayElement,
  timeSelectionHeaderElement,
}: LastActionsSelectOptionsProps<T>) => {
  const customDate = new CustomDate();

  const sortedRepositoryOptions = repositoryOptions.sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime());

  const getOptionsByTimeRange = (daysAgo: number, previousOptions: T[]) => {
    return sortedRepositoryOptions.filter((option) => {
      return customDate.isWithinDaysAgo(option.createdAt, daysAgo) && !previousOptions.includes(option);
    });
  };

  let previousOptions: T[] = [];
  const selection = timeRanges.reduce((acc: ItemSelectOption<T>[], { daysAgo, title }) => {
    const optionsByTimeRange = getOptionsByTimeRange(daysAgo, previousOptions);
    previousOptions = [...previousOptions, ...optionsByTimeRange];

    if (optionsByTimeRange.length > 0) {
      acc.push(
        {
          value: null,
          display: timeSelectionHeaderElement(title),
        },
        ...optionsByTimeRange.map((option) => ({ value: option, display: renderDisplayElement(option) })),
      );
    }
    return acc;
  }, []);

  return selection;
};
